import { createStore } from 'zustand/vanilla';

export type SelectedProductState = {
    sku: string;
    webStyleId: string;
};

export type SelectedProductActions = {
    setSku: (newSku: string) => void;
    setWebStyleId: (newWebStyleId: string) => void;
};

export type SelectedProductStore = Prettify<SelectedProductState & SelectedProductActions>;

export const createSelectedProductStore = (initState: SelectedProductState) => {
    return createStore<SelectedProductStore>()((set, get) => ({
        ...initState,
        setSku: (newSku: string) => get().sku !== newSku && set({ sku: newSku }),
        setWebStyleId: (newWebStyleId: string) =>
            get().webStyleId !== newWebStyleId && set({ webStyleId: newWebStyleId }),
    }));
};
